import { registerPropertyManagerSection } from '@/core';
import SectionViewPropertySection from '@/components/editor/property-manager/section-view/SectionViewPropertySection.vue';
import {
  getSectionViewUiRevision,
  notifySectionViewUiStateChanged,
  resolveSectionViewController,
} from '@/utils';

/**
 * 读取剖面视图确认按钮禁用状态。
 *
 * @param context PropertyManager 上下文。
 * @returns 当前草稿无效时返回 true。
 */
function resolveSectionViewConfirmDisabled(context: { renderer?: unknown }): boolean {
  return resolveSectionViewController(context.renderer)?.getState().canConfirm !== true;
}

/**
 * 订阅剖面视图确认状态变化。
 *
 * @param context PropertyManager 上下文。
 * @param listener 宿主状态失效回调。
 * @returns 控制器提供的取消订阅函数。
 */
function subscribeSectionViewConfirmState(
  context: { renderer?: unknown },
  listener: () => void,
): (() => void) | void {
  return resolveSectionViewController(context.renderer)?.subscribeStateChanged(listener);
}

registerPropertyManagerSection({
  id: 'section-view',
  title: '剖面视图',
  order: 5,
  component: SectionViewPropertySection,
  exclusive: true,
  actions: {
    confirm: true,
    cancel: true,
  },
  isApplicable: (context) => {
    // 修订信号只驱动 Vue 重新取快照，不让 Viewer 或控制器进入响应式链路。
    void getSectionViewUiRevision().value;
    return context.readonlyPreview !== true
      && resolveSectionViewController(context.renderer)?.getState().isEditing === true;
  },
  resolveConfirmDisabled: resolveSectionViewConfirmDisabled,
  subscribeConfirmState: subscribeSectionViewConfirmState,
  onConfirm: (context) => {
    resolveSectionViewController(context.renderer)?.confirm();
    notifySectionViewUiStateChanged();
  },
  onCancel: (context) => {
    resolveSectionViewController(context.renderer)?.cancel();
    notifySectionViewUiStateChanged();
  },
});
